import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { TableListComponent } from './table-list/table-list.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { IgxCalendarModule } from 'igniteui-angular';
import { HttpClientModule } from '@angular/common/http';
import { RightNavComponent } from './right-nav/right-nav.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { BottomSheetComponent } from './table-list/bottom-sheet/bottom-sheet.component';
import { SanitanizePipe } from './sanitanize.pipe';
import { DialogueComponent } from './table-list/dialogue/dialogue.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TableListeService } from './service/tableListe.service';
import { ParamDiversService } from './service/paramDivers.service';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from './config/format-datepicker';
import { DialogueRelationComponent } from './table-list/dialogue-relation/dialogue-relation.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DatabaseComponent } from './database/database.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SearchBarComponent } from './search-bar/search-bar.component';
import {CommonModule} from "@angular/common";

@NgModule({
  declarations: [
    AppComponent,
    TableListComponent,
    RightNavComponent,
    BottomSheetComponent,
    SanitanizePipe,
    DialogueComponent,
    DialogueRelationComponent,
    DatabaseComponent,
    SearchBarComponent,
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatSidenavModule,
        MatGridListModule,
        MatCardModule,
        MatButtonModule,
        MatDividerModule,
        MatListModule,
        MatTableModule,
        MatPaginatorModule,
        MatInputModule,
        MatIconModule,
        IgxCalendarModule,
        HttpClientModule,
        MatSelectModule,
        FormsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatBottomSheetModule,
        MatDialogModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        CommonModule,
    ],
  providers: [
    {provide: DateAdapter, useClass: AppDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS},
    {provide: LOCALE_ID, useValue: 'fr' },
    TableListeService,
    ParamDiversService
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    BottomSheetComponent,
    DialogueComponent,
    DialogueRelationComponent,
    DatabaseComponent,
  ]
})
export class AppModule {}
